import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const apiEndPoint = process.env.REACT_APP_API_URL;
// import { Instance } from "../../Context/axiosContext";
// let rowOffsetTime = 0;
// function utcTime(date) {
//   let date3 = Math.floor(new Date(date) / 1000) - rowOffsetTime;
//   return Math.floor(new Date(date3 * 1000).getTime());
// }
const GetLiveOrder = createAsyncThunk("GetLiveOrder", async (token) => {
  try {
    // const axiosInstance = Instance();
    console.log("token data", token);
    let response;
    if (token?.lastEvaluatedKey === "") {
      response = await axios.post(
        `${apiEndPoint}restaurant/orders/list?start=${token.startDate}&end=${token.endDate}&filter=${token.filter}&PageName=live_orders`,
        {
          lastEvaluatedKey: null,
          limit: "50",
          datenow: new Date().getTime(),
        },
        {
          headers: {
            Authorization: `${token.token}`,
            ["x-api-key"]: localStorage.getItem("apikey"),
          },
        }
      );
    } else {
      response = await axios.post(
        `${apiEndPoint}restaurant/orders/list?start=${token.startDate}&end=${token.endDate}&filter=${token.filter}&PageName=live_orders`,
        {
          lastEvaluatedKey: token.lastEvaluatedKey,
          limit: "50",
          datenow: new Date().getTime(),
        },
        {
          headers: {
            Authorization: `${token.token}`,
            ["x-api-key"]: localStorage.getItem("apikey"),
          },
        }
      );
    }
    if (response.data) {
      console.log("liveOrder list", response);
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    }
    if (error.message) {
      throw new Error(error.message);
    }
  }
});
export default GetLiveOrder;
